import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import useStandardTroopScheduleSteps from "./hooks/useStandardTroopScheduleSteps";

const StandardTroopScheduleSteps = () => {
    const standardTroopScheduleStepsData = useStandardTroopScheduleSteps();

    return (
        <div class="container container-fluid">
            <ButtonsSection ctaButtons={standardTroopScheduleStepsData.leftButtons} align="left" />
            <div className="header-section">
                <h1>
                    {standardTroopScheduleStepsData.screen_title} -{" "}
                    <span className="heading-cod">{standardTroopScheduleStepsData.screenNumber}</span>
                </h1>
            </div>
            <SearchBox
                formFields={standardTroopScheduleStepsData.formFields}
                dropdownValues={standardTroopScheduleStepsData.dropdownValues}
                paramsData={standardTroopScheduleStepsData.paramsData}
                updataParamData={standardTroopScheduleStepsData.updateParamData}
            />
            <ButtonsSection ctaButtons={standardTroopScheduleStepsData.ctaButtons} />
            <DisplayTable
                data={standardTroopScheduleStepsData.data}
                parmKey={standardTroopScheduleStepsData.parmKey}
                menuOptions={standardTroopScheduleStepsData.menuOptions}
                tableHeaders={standardTroopScheduleStepsData.columnDef}
                setRowData={standardTroopScheduleStepsData.setRowData}
                selectedPriceSchedules={standardTroopScheduleStepsData.selectedRows}
                setSelectedPriceSchedules={standardTroopScheduleStepsData.setSelectedRows}
            />
            <div className="paginator-container">
                <NextGenPaginator
                    first={standardTroopScheduleStepsData.first}
                    rows={standardTroopScheduleStepsData.rows}
                    totalRecords={standardTroopScheduleStepsData.totalRecords}
                    currentPage={standardTroopScheduleStepsData.currentPage}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPageChange={standardTroopScheduleStepsData.onPageChange}
                />
            </div>
        </div>
    );
};

export default StandardTroopScheduleSteps;